import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppConfig } from '../../config/app.config';

import { User } from '../models/user';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable()
export class UserService {

  private url: string;  // URL to web api

  constructor(private http: HttpClient) {
    this.url = AppConfig.endpoints.api;
  }

  /** Autenticates user in server */
  login(user: User): Observable<any> {
    return this.http.post(`${this.url}login`, user);
  }

  /** Logout user in server */
  logout(): Observable<any> {
    return this.http.post<User>(this.url + 'logout', httpOptions);
  }
}
